import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import theme from "../theme";
import { memo } from "react";

interface SpinnerProps {
  width?: string;
  height?: string;
  color?: string;
}

// 텍스트 로딩될 때 사용
export const DotLoader: React.FC<SpinnerProps> = memo((props) => {
  const {
    width = "40px",
    height = "8px",
    color = theme.statusColor.MAIN,
  } = props;

  return <Main width={width} height={height} color={color}></Main>;
});

const dotLoadetAni = keyframes`
  33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}
    50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}
    66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0%  }
`;

const Main = styled.div<{ width: string; height: string; color: string }>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: radial-gradient(
        circle closest-side,
        ${({ color }) => color} 90%,
        #0000
      )
      0% 50%,
    radial-gradient(
        circle closest-side,
        ${({ color }) => color} 90%,
        #0000
      )
      50% 50%,
    radial-gradient(
        circle closest-side,
        ${({ color }) => color} 90%,
        #0000
      )
      100% 50%;
  background-size: calc(100% / 3) 100%;
  background-repeat: no-repeat;
  animation: ${dotLoadetAni} 1s infinite linear;
`;
